import { useUsage } from "../contexts/UsageContext";

const dismissKey = (resetsAt: string) => `dc:usage-warning-dismissed:${resetsAt}`;

function readDismissed(resetsAt: string): boolean {
    try {
        return window.localStorage.getItem(dismissKey(resetsAt)) === "1";
    } catch {
        return false;
    }
}

/**
 * The free plan usage warning: shown from the usage gate's warn threshold until it is dismissed for
 * the period, and always at the limit, because calls are paused.
 */
export function useUsageWarning() {
    const { usage, billingVisible, warnAtPct, usageWarningDismissedFor, setUsageWarningDismissedFor } = useUsage();

    const pct = usage?.plan === "free" && usage.callsIncluded !== null && billingVisible ? usage.pct : null;
    const atLimit = pct !== null && pct >= 100;
    const dismissed = usage !== null && (usageWarningDismissedFor === usage.resetsAt || readDismissed(usage.resetsAt));
    const visible = atLimit || (pct !== null && pct >= warnAtPct && !dismissed);

    const dismiss = () => {
        if (!usage) {
            return;
        }
        try {
            window.localStorage.setItem(dismissKey(usage.resetsAt), "1");
        } catch {
            // Private mode or blocked storage: still hide it for this page view.
        }
        setUsageWarningDismissedFor(usage.resetsAt);
    };

    return {
        visible,
        atLimit,
        dismiss,
    };
}
